import React, { useState, useEffect } from 'react';
import { Input, Button, Checkbox, message, Card, Row, Col, Typography, Affix } from 'antd';
import { Editor } from '@monaco-editor/react';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';

const { Title } = Typography;

const CreateClass = ({ onBack, fetchClasses,classData }) => {
  const [className, setClassName] = useState('');
  const [classCode, setClassCode] = useState('# Write your Ruby class code here');
  const [isActive, setIsActive] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if(classData){
        setClassName(classData.class_name);
        setIsActive(classData.active);
        setClassCode(classData.classcode);
    }
    else{
        setClassName('');
        setIsActive(false);
        setClassCode('#Enter Your Class Code Here');

    }

}, [classData]);

  const handleCodeChange = (value) => {
    setClassCode(value || '');
    setErrorMessage('');
    // Extract class name from the code
    const classNameMatch = value?.match(/class\s+([A-Za-z0-9_]+)/);
    if (classNameMatch) {
        setClassName(classNameMatch[1]);
    } else {
        setClassName(''); // Reset if class name is not found
    }
  };

  const saveClass = async (goBack = false) => {
    const body = {
      class_metadata: {
        class_name: className,
        class_content: classCode,
        active: isActive,
      },
    };

    if (classData) {
      body.class_metadata._id = classData._id;
    }

    try {
      const apiService = new ApiService(
        `${BASE_URL}/ruby_class`,
        { "Content-Type": "application/json" },
        "PATCH",
        body
      );

      const res = await apiService.makeCall();

      message.success(
        classData
          ? "Class updated successfully"
          : "Class created successfully"
      );

      // ONLY refresh parent list if leaving page
      if (goBack) {
        fetchClasses();
        onBack();
      }

      return res;
    } catch (error) {

      let parsedErrors = [];

      if (error && error.message) {
        const errorMessage = error.message;

        const errorLines = errorMessage.split("<compiled>");

        errorLines.forEach((line) => {
          if (line.trim().length > 0) {
            const match = line.match(/:(\d+): (.*)/);

            if (match) {
              parsedErrors.push({
                line: match[1],
                message: match[2],
              });
            }
          }
        });
      } else {
        parsedErrors.push({
          message: error || "An unknown error occurred",
          line: "No line info available",
        });
      }

      setErrorMessage(parsedErrors);
    }
  };

  const handleSave = async () => {
    await saveClass(true); // save + go back
  };

  const handleQuickSave = async () => {
    await saveClass(false); // save only
  };
  const handleCancel = () => {
    setClassName('');
    setClassCode('');
    setIsActive(false);
    onBack(); // Go back to the main screen
  };
  
  const callOnBack = ()=>{
    setClassName('');
    setClassCode('');
    setIsActive(false);
    onBack(); // Go back to the main screen
}

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
        <Col>
          <Title level={4}>Create Class</Title>
        </Col>
        <Col>
          <Button type="default" onClick={callOnBack}>Back</Button>
        </Col>
      </Row>

      <div>
        <Row>
          <Col span={24}>
            <Input
              placeholder="Class Name"
              value={className}
              onChange={(e) => setClassName(e.target.value)}
              style={{ marginBottom: '16px' }}
              disabled
            />
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Checkbox
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              style={{ marginBottom: '8px' }}
            >
              Active
            </Checkbox>
          </Col>
          
        </Row>

        <Row>
  <Col span={24}>
    <label htmlFor="script">Write your class code here</label>
    <h3>Help</h3>
    <ul>
      <li>
        <strong>Class Name will automatically match with the below Class Name</strong>
      </li>
    </ul>

    {/* Displaying parsed errors */}
    {errorMessage.length > 0 && (
      <div style={{ margin: '10px 0', color: 'red' }}>
        <h4>Errors:</h4>
        <ul>
          {errorMessage.map((error, index) => (
            <li key={index}>
              <strong>Line {error.line}:</strong> {error.message}
            </li>
          ))}
        </ul>
      </div>
    )}

    <div style={{ height: '400px', border: '1px solid #ddd' }}>
      <Editor
        height="100%"
        defaultLanguage="ruby"
        theme="vs-light"
        value={classCode}
        onChange={handleCodeChange}
      />
    </div>
  </Col>
</Row>
      </div>

      <Affix offsetBottom={0}>
        <div
          style={{
            position: 'sticky',
            bottom: 0,
            background: 'rgba(240, 242, 245, 0.9)',
            padding: '10px 0',
            boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
          }}
        >
          <Button type="primary" onClick={handleQuickSave} style={{ marginRight: 10 }}>
            Quick Save
          </Button>
          <Button type="primary" onClick={handleSave} style={{ marginRight: 10 }}>
            Save Class
          </Button>
          <Button type="default" onClick={handleCancel}>
            Cancel
          </Button>
        </div>
      </Affix>
    </div>
  );
};

export default CreateClass;
